const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;',
};

// ECharts' default tooltip renderMode is 'html', so whatever a tooltip
// formatter returns gets inserted via innerHTML, not React's JSX escaping.
// Any value sourced from a user-editable field (channel/device/controller
// names) must go through this before being concatenated into tooltip
// markup, or a malicious name becomes stored DOM-XSS for anyone who hovers
// a chart data point.
export const escapeHtml = (value: unknown): string =>
  String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char]);
